import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "./layouts/dashboard";
import SimpleLayout from "./layouts/simple";
import AddEditNewsPage from "./pages/AddEditNewsPage";
import AdminInboxMessagePage from "./pages/AdminInboxMessagePage";
import AdminInboxMessagesPage from "./pages/AdminInboxMessagesPage";
import AdminsPage from "./pages/AdminsPage";
import AppSettingsPage from "./pages/AppSettingsPage";
import CoinTransactionPage from "./pages/CoinTransactionPage";
import CoinTransactionsPage from "./pages/CoinTransactionsPage";
import DashboardAppPage from "./pages/DashboardAppPage";
import DashboardPage from "./pages/DashboardPage";
import GameProviderEditPage from "./pages/GameProviderEditPage";
import GameProvidersPage from "./pages/GameProvidersPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import MarketplaceDashboardPage from "./pages/MarketplaceDashboardPage";
import NewsCategoriesListPage from "./pages/NewsCategoriesListPage";
import NewsListPage from "./pages/NewsListPage";
import Page404 from "./pages/Page404";
import ProfileEditPage from "./pages/ProfileEditPage";
import ProfilePage from "./pages/ProfilePage";
import ProfilePageNew from "./pages/ProfilePage";
import StoreItemsPage from "./pages/StoreItemsPage";
import UserPage from "./pages/UserPage";
import GameUsersPage from "./pages/UsersPage";
import UsersPage from "./pages/UsersPage";
import VideoCategoriesPage from "./pages/VideoCategoriesPage";
import VideosPage from "./pages/VideosPage";
import VoucherPage from "./pages/VoucherPage";

export default function Router() {
	return useRoutes([
		{
			path: "/dashboard",
			element: <DashboardLayout />,
			children: [
				{ element: <Navigate to="/dashboard/home" />, index: true },
				{ path: "home", element: <HomePage /> },
				{ path: "admins", element: <AdminsPage /> },
				{ path: "arcade", element: <GameProvidersPage /> },
				{ path: "arcade/:id", element: <GameProviderEditPage /> },
				{ path: "vouchers", element: <VoucherPage /> },
				{ path: "users", element: <UsersPage /> },
				{ path: "app-settings", element: <AppSettingsPage /> },
				{ path: "profile", element: <ProfilePage /> },
				{ path: "profile-new", element: <ProfilePageNew /> },
				{ path: "profile-edit", element: <ProfileEditPage /> },
				{ path: "marketplace", element: <MarketplaceDashboardPage /> },
				{ path: "marketplace-store-items", element: <StoreItemsPage /> },
				{ path: "coin-transactions", element: <CoinTransactionsPage /> },
				{ path: "coin-transaction", element: <CoinTransactionPage /> },
				{ path: "inbox", element: <AdminInboxMessagesPage /> },
				{ path: "inbox/message", element: <AdminInboxMessagePage /> },
				{ path: "game/dashboard", element: <DashboardPage /> },
				{ path: "game/users", element: <GameUsersPage /> },
				{ path: "app", element: <DashboardAppPage /> },
				{ path: "user", element: <UserPage /> },

				{ path: "news-categories", element: <NewsCategoriesListPage /> },
				{ path: "news", element: <NewsListPage /> },
				{ path: "news/add", element: <AddEditNewsPage /> },
				{ path: "news/edit/:id", element: <AddEditNewsPage /> },

				{ path: "video-categories", element: <VideoCategoriesPage /> },
				{ path: "videos", element: <VideosPage /> },

				{ path: "settings", element: <AppSettingsPage /> },
			],
		},
		{
			path: "login",
			element: <LoginPage />,
		},
		{
			element: <SimpleLayout />,
			children: [
				{ element: <Navigate to="/dashboard/home" />, index: true },
				{ path: "404", element: <Page404 /> },
				{ path: "*", element: <Navigate to="/404" /> },
			],
		},
		{
			path: "*",
			element: <Navigate to="/404" replace />,
		},
	]);
}
